exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button {\n\tfloat: right;\n}\n\n.card-save-wrapper {\n    float: right;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/global-payment/global-payment.component.css
// module id = ../../../../../src/app/components/payment/global-payment/global-payment.component.css
// module chunks = main